<div class="plan">

    <!-- ============ INTRO ============ -->
    <section class="plan__intro rs-container" [rsReveal]="0">
        <p class="rs-eyebrow rs-eyebrow--center">Mittagstisch</p>
        <h2 class="plan__intro__title">Täglich zwei wechselnde Menüs</h2>
        <p class="plan__intro__text">
            Frisch gekocht aus unserer eigenen Metzgerei. Einfach bis 11:00 Uhr online vorbestellen,
            Abholzeit auswählen, abholen &amp; genießen.
        </p>
        <a class="rs-btn rs-btn--primary"
           href="https://bestellen.marktstubn.com/"
           target="_blank"
           rel="noopener">
            Jetzt vorbestellen
            <span class="plan__arrow" aria-hidden="true">→</span>
        </a>
    </section>

    <!-- ============ SPOTLIGHT ============ -->
    <section class="plan__spotlight rs-container" *ngIf="spotlightMenus.length" [rsReveal]="0">
        <div class="plan__spotlight__media">
            <img src="assets/img/speiseplan/burger-banner.jpg"
                 alt="Frisch zubereitete Burger vom Grill"
                 loading="lazy">
            <span class="plan__spotlight__tag">{{isSpotlightToday ? 'Heute' : spotlightWeekday}}</span>
        </div>

        <div class="plan__spotlight__body">
            <p class="rs-eyebrow">{{isSpotlightToday ? 'Heute am Teller' : 'Als Nächstes'}}</p>
            <h3 class="plan__spotlight__title">{{spotlightWeekday}} in der Marktstub'n</h3>

            <div class="plan__spotlight__menus">
                <div class="plan__menu" *ngFor="let menu of spotlightMenus; let i = index">
                    <span class="plan__menu__label">Menü {{i + 1}}</span>
                    <p class="plan__menu__starter" *ngIf="menu.vorspeise">{{menu.vorspeise}}</p>
                    <p class="plan__menu__main">{{menu.hauptspeise}}</p>
                    <p class="plan__menu__price" *ngIf="menu.preis">€ {{menu.preis}}</p>
                </div>
            </div>

            <a class="rs-btn rs-btn--primary"
               href="https://bestellen.marktstubn.com/"
               target="_blank"
               rel="noopener">Jetzt vorbestellen</a>
        </div>
    </section>

    <!-- ============ WOCHE ============ -->
    <section class="plan__week rs-container">
        <div class="plan__section-head" [rsReveal]="0">
            <div>
                <p class="rs-eyebrow">Menüplan</p>
                <h3 class="plan__section-title">Die Woche auf dem Teller</h3>
            </div>
            <p class="plan__section-note">Montag bis Freitag, jeweils zwei Menüs zur Auswahl.</p>
        </div>

        <div class="plan__grid">
            <ng-container *ngFor="let weekdayMenu of weekdayMenuCollection; let i = index">
                <article class="plan__day"
                         *ngIf="hasMenu(weekdayMenu)"
                         [rsReveal]="i * 70"
                         [class.plan__day--today]="weekdayMenu.day === currentWeekday">
                    <header class="plan__day__head">
                        <h3 class="plan__day__title">{{weekdayMenu.day}}</h3>
                        <span class="plan__day__badge" *ngIf="weekdayMenu.day === currentWeekday">Heute</span>
                    </header>

                    <div class="plan__menu" *ngIf="weekdayMenu.menu1?.hauptspeise">
                        <span class="plan__menu__label">Menü 1</span>
                        <p class="plan__menu__starter" *ngIf="weekdayMenu.menu1?.vorspeise">
                            {{weekdayMenu.menu1?.vorspeise}}
                        </p>
                        <p class="plan__menu__main">{{weekdayMenu.menu1?.hauptspeise}}</p>
                        <p class="plan__menu__price" *ngIf="weekdayMenu.menu1?.preis">
                            € {{weekdayMenu.menu1?.preis}}
                        </p>
                    </div>

                    <div class="plan__menu" *ngIf="weekdayMenu.menu2?.hauptspeise">
                        <span class="plan__menu__label">Menü 2</span>
                        <p class="plan__menu__starter" *ngIf="weekdayMenu.menu2?.vorspeise">
                            {{weekdayMenu.menu2?.vorspeise}}
                        </p>
                        <p class="plan__menu__main">{{weekdayMenu.menu2?.hauptspeise}}</p>
                        <p class="plan__menu__price" *ngIf="weekdayMenu.menu2?.preis">
                            € {{weekdayMenu.menu2?.preis}}
                        </p>
                    </div>
                </article>
            </ng-container>
        </div>

        <p class="plan__empty" *ngIf="menusLoaded && !weekdayMenuCollection.length">
            Aktuell ist kein Menüplan hinterlegt – ein Blick später lohnt sich.
        </p>
    </section>

    <!-- ============ WOCHENKARTE ============ -->
    <section class="plan__weekly" *ngIf="weeklyMenuCollection.length">
        <div class="rs-container">
            <div class="plan__weekly__head" [rsReveal]="0">
                <p class="rs-eyebrow rs-eyebrow--center">Die ganze Woche</p>
                <h2 class="plan__intro__title">Wochenkarte</h2>
                <p class="plan__intro__text">
                    Klassiker, die es jeden Tag gibt – zusätzlich zu den beiden Tagesmenüs.
                </p>
            </div>
            <div class="plan__weekly__grid">
                <ng-container *ngFor="let weeklyMenu of weeklyMenuCollection; let i = index">
                    <article class="plan__weekly__card"
                             *ngIf="weeklyMenu.menu.hauptspeise"
                             [rsReveal]="(i % 4) * 70">
                        <p class="plan__menu__main">{{weeklyMenu.menu.hauptspeise}}</p>
                        <p class="plan__menu__price" *ngIf="weeklyMenu.menu.preis">€ {{weeklyMenu.menu.preis}}</p>
                    </article>
                </ng-container>
            </div>
        </div>
    </section>

    <!-- ============ ABLAUF ============ -->
    <section class="plan__how">
        <div class="rs-container plan__how__inner">
            <div class="plan__how__body" [rsReveal]="0">
                <p class="rs-eyebrow">Vorbestellen</p>
                <h3 class="plan__how__title">Am besten schmeckts,<br>wenns von dahoam is.</h3>

                <ol class="plan__steps">
                    <li>
                        <span class="plan__steps__no">01</span>
                        <div>
                            <p class="plan__steps__title">Menü wählen</p>
                            <p class="plan__steps__text">Online im Bestellsystem, bis 11:00 Uhr am selben Tag.</p>
                        </div>
                    </li>
                    <li>
                        <span class="plan__steps__no">02</span>
                        <div>
                            <p class="plan__steps__title">Abholzeit festlegen</p>
                            <p class="plan__steps__text">Fertig genau zur Wunschzeit – ganz ohne Wartezeit.</p>
                        </div>
                    </li>
                    <li>
                        <span class="plan__steps__no">03</span>
                        <div>
                            <p class="plan__steps__title">Abholen &amp; genießen</p>
                            <p class="plan__steps__text">In der Marktstubn essen oder frisch verpackt mitnehmen.</p>
                        </div>
                    </li>
                </ol>

                <a class="rs-btn rs-btn--primary"
                   href="https://bestellen.marktstubn.com/"
                   target="_blank"
                   rel="noopener">Jetzt vorbestellen</a>
            </div>

            <div class="plan__how__media" [rsReveal]="120">
                <img src="assets/img/gallery/imbiss.jpg" alt="Imbiss- und Kaffeetheke der Marktstubn" loading="lazy">
            </div>
        </div>
    </section>

    <!-- ============ IMPRESSIONEN ============ -->
    <section class="plan__impressions">
        <div class="rs-container">
        <div class="plan__impressions__head" [rsReveal]="0">
            <p class="rs-eyebrow rs-eyebrow--center">Bei uns</p>
            <h3 class="plan__section-title">Platz nehmen und bleiben</h3>
            <p class="plan__section-note">Drinnen in der Marktstubn, draußen auf der Terrasse – oder eingepackt für unterwegs.</p>
        </div>

        <div class="plan__impressions__grid">
            <figure class="plan__impressions__item"
                    *ngFor="let image of impressions; let i = index"
                    [rsReveal]="i * 80">
                <img [src]="image.src" [alt]="image.alt" loading="lazy">
                <figcaption>{{image.caption}}</figcaption>
            </figure>
        </div>
        </div>
    </section>

    <!-- ============ INFO ============ -->
    <section class="plan__info">
        <div class="rs-container plan__info__inner" [rsReveal]="0">
            <div class="plan__info__text">
                <p class="rs-eyebrow">Gut zu wissen</p>
                <h3 class="plan__info__title">Mittagstisch<br>von Montag bis Freitag</h3>
                <p class="plan__info__note">
                    Hans Kappacherstraße 9, 5600 St. Johann im Pongau.<br>
                    Warme Küche bis 15:00 Uhr, Vorbestellungen bis 11:00 Uhr.
                </p>
            </div>
            <div class="plan__info__actions">
                <a class="rs-btn rs-btn--solid-light"
                   href="https://bestellen.marktstubn.com/"
                   target="_blank"
                   rel="noopener">Jetzt vorbestellen</a>
                <a class="rs-btn rs-btn--light"
                   href="https://www.openstreetmap.org/?mlat=47.3469044&mlon=13.2023823#map=18/47.34690/13.20238"
                   target="_blank"
                   rel="noopener">Route planen</a>
            </div>
        </div>
    </section>

    <app-family-story></app-family-story>
</div>
